<template>
    <div class="d-flex flex-column justify-content-center px-1">
    <HeaderBar/>
    <div
      class="d-flex flex-column mb-2 mt-4"
      style="font-size: 15px; font-weight: 500"
    >
        <div class="add-economic-record-title1 mt-2 text-center "> Secado de vacas</div>
        <div class="d-flex justify-content-center headTitle">{{fincaName}}</div>
    </div>
    <validation-observer ref="GanForm">
      <b-form-group label="Fecha" label-for="date">
        <validation-provider
        #default="{ errors }" 
        name="Fecha" 
        rules="required">
        <b-form-datepicker v-model="date" class="form-control" 
        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        :min="minCfgDate" :max="maxCfgDate"/>
        <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <div>Seleccionar Animales</div>
                    <b-form-group label="Animales" label-for="animal">
                        <small> ⬇ Seleccionar todos</small>
                        <vue-good-table :columns="columns" :rows="rows" 
                        :search-options="{
                            enabled: false,
                        }" 
                        
                        :sort-options="{
                            enabled: true,
                        }"

                        :pagination-options="{
                            enabled: true,
                            perPage: pageLength,
                            mode:'records',
                            nextLabel: ' Siguiente > ',
                            prevLabel: ' < Anterior ',
                            perPageDropdown: [10, 20,50,100],
                            dropdownAllowAll: false,
                            rowsPerPageLabel: 'Animales por página',
                            ofLabel: 'de',
                            position: 'bottom',
                            pageLabel: 'página',
                        }"

                        :select-options="{
                            enabled: true,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                            disableSelectInfo: true, // disable the select info panel on top
                            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                        }"

                        @on-selected-rows-change="selectedAnimal"
                        >
                        <template slot="table-row" slot-scope="props">

                            <!-- Column: Name -->
                            <span v-if="props.column.field === 'sex'" class="text-center">
                            <span v-if="props.row.sex===false" class="text-center">M</span>
                            <span v-if="props.row.sex===true" class="text-center">H</span>
                            
                            </span>

                            <!-- Column: Status -->
                            <span v-else-if="props.column.field === 'status'">
                            <b-badge :variant="statusVariant(props.row.status)">
                                {{ props.row.status }}
                            </b-badge>
                            </span>

                            <!-- Column: Common -->
                            <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>

                        <!-- pagination -->
                       <!--  <template slot="pagination-bottom" slot-scope="props">
                            <div class="d-flex justify-content-between flex-wrap">
                            <div class="d-flex align-items-center mb-0 mt-1">
                                <span class="text-nowrap ">
                                Mostrando 1 de
                                </span>
                                <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
                                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                                <span class="text-nowrap"> of {{ props.total }} registros </span>
                            </div>
                            </div>
                        </template> -->
                        </vue-good-table>
                    </b-form-group>

      <b-button class="d-flex bg-primary mt-5" @click="insertMilk">
        <div class="ml-3">Secar Vacas Seleccionadas</div>
        <div class="ml-3" style="color: #d7b92c">
          <feather-icon icon="PlusIcon" size="20" /></div
      ></b-button>
    </validation-observer>
      <ControlMenu />
    </div>
  </template>
  
  <script>
  import ControlMenu from "@/components/ControlMenu.vue"
  import HeaderBar from '@/components/HeaderBar.vue'
  import flatPickr from "vue-flatpickr-component"
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { required } from '@validations'
  import vSelect from "vue-select";
  import { BFormGroup, BImg, BButton, BFormDatepicker,BFormSelect } from "bootstrap-vue"
  import { VueGoodTable } from 'vue-good-table'
  import axios from 'axios'

  export default {
    components: {
      ControlMenu,
      HeaderBar,
      BImg,
      BButton,
      flatPickr,
      vSelect,
      BFormGroup,
      BFormDatepicker,
      BFormSelect,
      ValidationProvider,
      ValidationObserver,
      VueGoodTable,
    },
    data() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      // 15th two months prior
      const minDate = new Date(today)
      minDate.setMonth(minDate.getMonth() - 119)
      minDate.setDate(15)
      // 15th in two months
      const maxDate = new Date(today)
      maxDate.setMonth
      maxDate.setMonth(maxDate.getMonth())
      maxDate.setDate(maxDate.getDate())
      return {
        fincaName:localStorage.getItem('currentFarmName'),
        farmId:localStorage.getItem('currentFarm'),
        date: now,
        pageLength: 10,
        maxCfgDate:maxDate,
        minCfgDate:minDate,
        animalOptions: [],
        columns: [
          {
            label: 'CODIGO',
            field: 'number',
          },  
          {
            label: 'ANIMAL',
            field: 'name',
          },
          {
            label: 'SEXO',
            field: 'sex',
          },
          {
            label: 'PESO',
            field: 'weight',
          },
          {
            label: 'EDAD',
            field: 'age',
          },
        ],
        rows: [],
        milks:[]
      };
    },
 
    methods: {
      async fetchAnimals(config){
        let self=this;
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&sex=1&dryed=0&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
          console.log(result.animals);
          result.animals.forEach(function(item) {
            if(item.age>=15){
              self.rows.push({
                  id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age
              })
            }
          })
          console.log(this.animals);
        })
      },
      selectedAnimal(params){
        console.log(params.selectedRows);
        this.milks= params.selectedRows.map(item=>{return {farm_id:this.farmId, animal_id:item.id, date:this.date}})
      },
      insertMilk(){
        this.$refs.GanForm.validate().then(success => {
          if(success){
            let self=this;
            console.log(this.milks);
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            var request= this.milks.map(items =>this.$http.post("add/dry_records", items, config));
            axios.all(request)
            .then((result)=>{
              console.log(result)
              this.$swal({
                title: 'Registro de producción de leche',
                text: 'Se insertaron los registros de secado de manera satisfactoria',
                type: 'success',
                icon:'success',
                showCancelButton: false,
                confirmButtonColor:'#5E8F23',
                showCloseButton: true,
                showLoaderOnConfirm: false  
              }).then(function(){
                history.back();
              });
            });
          }
        })
      },

    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchAnimals(config);
    },
  };
  </script>
  <style>
.footer__navigation__page-btn {
  background-color: #5e8f23; /* color de fondo */
  color: white; /* color del texto */
  border-radius: 4px;
  padding: 5px 10px;
  text-align:center;
}
.footer__row-count{
  margin-top:10px;
}
.footer__navigation, .vgt-pull-right{
  text-align:center!important;
  width:100%;
  display:grid;
  margin-top:10px;
}
</style>